import React from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { Controller } from 'react-hook-form';

// Child Component: StatusRadioGroup
const StatusRadioGroup = ({
  control,
  defaultValue,
  rules,
  disabled,
  title,
  name,
}) => {
  return (
    <Box>
      <Typography variant='subtitle1' gutterBottom>
        {title} Status
      </Typography>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <RadioGroup
            row
            {...field}
            value={field.value || defaultValue} // Ensure value is set properly
          >
            {defaultValue === 'Active' || defaultValue === 'Inactive' ? (
              <>
                <FormControlLabel
                  value='Active'
                  control={
                    <Radio
                      color='success'
                      sx={{
                        '&.Mui-checked': {
                          color: 'green', // Color when checked
                        },
                      }}
                    />
                  }
                  label='Active'
                  disabled={disabled}
                />
                <FormControlLabel
                  value='Inactive'
                  control={
                    <Radio
                      color='secondary'
                      sx={{
                        // '&.Mui-disabled': {
                        //   color: 'red', // Color for disabled Radio
                        // },
                        '&.Mui-checked': {
                          color: 'red', // Color when checked
                        },
                      }}
                    />
                  }
                  label='Inactive'
                  disabled={disabled}
                />
              </>
            ) : (
              <>
                <FormControlLabel
                  value='Approved'
                  control={
                    <Radio
                      sx={{
                        '&.Mui-checked': {
                          color: 'green', // Color when checked
                        },
                      }}
                    />
                  }
                  label='Approved'
                  disabled={disabled}
                />
                <FormControlLabel
                  value='Pending'
                  control={
                    <Radio
                      color='warning'
                      sx={{
                        '&.Mui-checked': {
                          color: 'orange', // Color when checked
                        },
                      }}
                    />
                  }
                  label='Pending'
                  disabled={disabled}
                />
                <FormControlLabel
                  value='Rejected'
                  control={
                    <Radio
                      color='error'
                      sx={{
                        '&.Mui-checked': {
                          color: 'red', // Color when checked
                        },
                      }}
                    />
                  }
                  label='Rejected'
                  disabled={disabled}
                />
              </>
            )}
          </RadioGroup>
        )}
      />
    </Box>
  );
};

export default StatusRadioGroup;
